import React from 'react'
import { Button } from 'antd'
import styled from 'styled-components'
import { accessibilityColors } from '@edulastic/colors'
import { IconClose } from '@edulastic/icons'

export const EduTagRemoveButton = ({ ariaLabel = 'Remove Tag', ...props }) => (
  <StyledButton tabIndex={0} aria-label={ariaLabel} {...props}>
    <StyledIconClose aria-hidden="true" aria-label={`${ariaLabel} Icon`} />
  </StyledButton>
)

const StyledButton = styled(Button)`
  width: fit-content;
  padding: 0px;
  height: 24px;
  background: none;
  outline: none;
  border: none;
  margin-top: 0px;
  margin-right: ${({ closeIconRightMargin }) =>
    closeIconRightMargin || '-30px'};
  &:hover {
    background: none;
  }
  &:focus {
    outline: 2px solid ${accessibilityColors.theme.blue};
    background: none;
  }
`

const StyledIconClose = styled(IconClose)`
  width: 10px;
  height: 10px !important;
`
